import { useState, useEffect } from 'react';

// Overload for the common string|undefined case (caller omits the generic)
export function useDebounce(initialValue?: string | undefined, delay?: number): [string | undefined, (value: string | undefined) => void];
// Generic overload for other types
export function useDebounce<T>(initialValue: T, delay?: number): [T, (value: T) => void];
// Implementation
export function useDebounce<T = string | undefined>(initialValue?: T, delay: number = 500): [T | undefined, (value: T | undefined) => void] {
  const [value, setValue] = useState<T | undefined>(initialValue);
  const [debouncedValue, setDebouncedValue] = useState<T | undefined>(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  const setter = (v: T | undefined) => setValue(v);

  return [debouncedValue, setter];
}
